/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IFilterField } from "Interfaces/IFilterField";

import { fieldTypes } from "./FilterFields";

export const CLAIMED_FROM = "claimedFrom";
export const CLAIMED_TO = "claimedTo";

export const defaultListingPageSize = 16;

export const m365CopilotFilterFields: IFilterField[] = [
  {
    key: CLAIMED_FROM,
    text: "Claimed From",
    type: fieldTypes.DATE_PICKER,
  },
  {
    key: CLAIMED_TO,
    text: "Claimed To",
    type: fieldTypes.DATE_PICKER,
  },
];

export const defaultFilterValues: {
  fieldName: string;
  value: string;
}[] = [];
